import axios from 'axios';
import qs from 'qs';

export const fetchContacts = async (params = {}) => {
  const {
    token,
    offset = 0,
    order = 'last_name',
    sort = 'asc',
    limit = process.env.REACT_APP_DEFAULT_PAGINATION_LIMIT,
    search,
    from,
    to,
    companyId,
  } = params;

  const queryString = { offset, order, sort, limit, search, from, to, companyId };

  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/contacts?${qs.stringify(queryString)}`,
      headers: {
        Authorization: token,
      },
    });

    if (response instanceof Error) {
      return { error: response }
    }

    return response;

  } catch (error) {
    return { error };
  }
};

export const createContact = async ({ data, token } = {}) => {
  try {
    const response = await axios({
      method: 'post',
      url: `${process.env.REACT_APP_API_URL}/contacts`,
      data,
      headers: {
        Authorization: token,
      },
    });

    if (response instanceof Error) {
      return { error: response }
    }

    return response;

  } catch (error) {
    return { error };
  }
};

export const saveContact = async ({ id, token, data = {} } = {}) => {
  try {
    const response = await axios({
      method: 'put',
      url: `${process.env.REACT_APP_API_URL}/contacts/${id}`,
      data,
      headers: {
        Authorization: token,
      },
    });

    if (response instanceof Error) {
      return { error: response }
    }
    
    return response;

  } catch (error) {
    return { error };
  }
};

export const deleteContact = async ({ id, token } = {}) => {
  try {
    const response = await axios({
      method: 'delete',
      url: `${process.env.REACT_APP_API_URL}/contacts/${id}`,
      headers: {
        Authorization: token,
      },
    });

    if (response instanceof Error) {
      return { error: response }
    }

    return response;

  } catch (error) {
    return { error };
  }
};

export const fetchContact = async ({ token, id } = {}) => {
  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/contacts/${id}`,
      headers: {
        Authorization: token,
      },
    });

    if (response instanceof Error) {
      return { error: response }
    }

    return response;

  } catch (error) {
    return { error };
  }
};

export const fetchUrgentContacts = async ({ token } = {}) => {
  try {
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/contacts/urgent`,
      headers: {
        Authorization: token,
      },
    });

    if (response instanceof Error) {
      return { error: response }
    }

    return response;

  } catch (error) {
    return { error };
  }
};

export const updateContactTimestamp = async ({ token, id } = {}) => {
  try {
    const fetchResponse = await fetchContact({ token, id });
    
    if (fetchResponse.error) {
      return { error: fetchResponse.error };
    }

    const contact = fetchResponse.data;
    const { first_name } = contact;

    const response = await axios({
      method: 'put',
      url: `${process.env.REACT_APP_API_URL}/contacts/${id}`,
      data: { first_name },
      headers: {
        Authorization: token,
      },
    });

    if (response instanceof Error) {
      return { error: response }
    }

    return response;

  } catch (error) {
    return { error };
  }
};